(function($){
  var ecoMap = {
    init: function(){
      if ($('#ecosystem-map').length){
        ecoMap.initEcoMap();
      }
    },
    initEcoMap: function(){

      //trigger aside
      $('.map__trigger').on('click', function() {
        $(this).parent().toggleClass('active');
      });

      //select icon
        var $icon = $('.map__icon');

      //map settings
      var mymap = {
        map: null,
        markerIcon: null,
        markerlock: false,
        popinopen: false
      };

      // Global coords/settings
      var lat = $('.map__lat').html();
      var long = $('.map__lng').html();
      var coord = [lat, long];
      var zoom = 8;
      var paddingTopLeft = [10, 105];
      var paddingBottomRight = [10, 10];

      // Init map
      mymap.map = L.map('ecosystem-map', { minZoom: 8 }).setView(coord, zoom);

      // Add tiles
      L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        }).addTo(mymap.map);

      // Create groups
      var fGroup = [];
      var fGroup2 = [];

      //Focus on address click
      function clickCenter(itm, itmLat, itmLng) {
        itmChild = itm.find('.address__text');
        itmChild.on('click', function() {
          $(this).parent().addClass('active');
          $(this).parent().removeClass('active');
          mymap.map.flyTo([itmLat, itmLng], 13);
        });
      }

      //Hide siblings on address click
      function filterList(itm) {
        $('#fmap-select').on('change', function() {
          var filter = $(this).val();
          console.log(filter);
          if (itm.data('filter') == filter)  {
            itm.css('display', 'block');
          } else if (filter == 0) {
            itm.css('display', 'block');
          } else {
            itm.css('display', 'none');
          }
        });
      }

      // Push addresses in groups
      $('.address').each(function() {
        var metaLat = $(this).find('meta[itemprop="latitude"]').attr('content');
        var metaLong = $(this).find('meta[itemprop="longitude"]').attr('content');
        var metaData = $(this).data('filter');
        var colorClass = $(this).data('color');

        clickCenter($(this), metaLat, metaLong);
        filterList($(this));

        $.each((''+metaData).split(','), function(key, group) {
          if (!$.isArray(fGroup[group])) {
            fGroup[group] = [];
          }

        var marker = L.marker([metaLat, metaLong], {
          icon: new L.divIcon({
            className: 'marker',
            html: '<svg role="img" class="icon icon-marker-big ' + colorClass + '"><use xlink:href="/themes/ovmap/assets/images/icons.sprite.svg#icon-marker-big"></use></svg>',
            iconAnchor: [24, 48]
          }),
          interactive: true
        });

          fGroup[group].push(marker);
        });

      });

      //Initial layer
      var allGroup = L.featureGroup();
      for (var index in fGroup) {
        fGroup2[index] = L.featureGroup(fGroup[index]);
        allGroup.addLayer(fGroup2[index]);
      }

      mymap.map.addLayer(allGroup);

      if ($('.tabs').first().data('term')) {
        var currFilter = $('.tabs').first().data('term');
      }

      // Change layers
      $('#fmap-select').on('change', function() {
        var filter = $(this).val();
        if (filter != 0 ) {

          if (mymap.map.hasLayer(allGroup)) {
            mymap.map.removeLayer(allGroup);
          }

          if (currFilter !== undefined && mymap.map.hasLayer(fGroup2[currFilter])) {
            mymap.map.removeLayer(fGroup2[currFilter]);
          }

          mymap.map.addLayer(fGroup2[filter]);
          mymap.map.fitBounds(fGroup2[filter].getBounds(), {paddingTopLeft: paddingTopLeft, paddingBottomRight: paddingBottomRight});
          currFilter = filter;

        } else {
          mymap.map.addLayer(allGroup);
          mymap.map.fitBounds(allGroup.getBounds(), {paddingTopLeft: paddingTopLeft, paddingBottomRight: paddingBottomRight});
        }

      });

  }

  };
  $(document).ready(ecoMap.init);
})(jQuery);
